<template>
  <nav v-if="isLogged">
    <div class="row bandeauTitre">
      <div class="col-xl-11 col-lg-10 col-md-10 col-sm-10 col-8">
        <span @click="version" class="text-left titre"><span class="autreLettreTitre">Why</span><span class="lettreTitre"><b>Note</b></span></span>
        <span v-if="!isHiddenVersion" id="version"> v1.0.5</span>
      </div>
      <div class="col-xl-1 col-lg-2 col-md-2 col-sm-2 col-4 iconDeconnexion">
        <span class="pseudo"><b>{{ getPseudo() }}</b></span>
        <span @click="logout" class="seDeconnecter">
          <i class="fas fa-sign-out-alt fa-2x logoutConnexion"></i>
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  data: () => {
    return {
      pseudo: '',
      isHiddenVersion: true
    }
  },
  computed: mapGetters([
    'isLogged'
  ]),
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
    getPseudo () {
      return localStorage.pseudo
    },
    version () {
      this.isHiddenVersion = !this.isHiddenVersion
    }
  }
}
</script>
<style scoped>
  .bandeauTitre {
    background-color: blueviolet;
    color: cornsilk;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .titre {
    padding-left: 10%;
    font-size: 3vw;
    cursor: pointer;
  }

  .seDeconnecter {
    color: #e0da1b;
    text-decoration: none;
    cursor: pointer;
  }

  .lettreTitre {
    color: #e0da1b;
  }

  .logoutConnexion:hover {
    color: cornsilk;
  }

  .iconDeconnexion {
    margin: auto;
  }

  .pseudo {
    padding-left: 10px;
    padding-right: 10px;
    color: cornsilk;
  }

  @media screen and (max-width: 600px) {
    .titre {
      font-size: 8vw;
    }

    .fa-2x {
      font-size: 5vw;
    }

    .pseudo {
      font-size: 4vw;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1024px) {
    .titre {
      font-size: 4vw;
    }

    .fa-2x {
      font-size: 2.5vw;
    }

    .pseudo {
      font-size: 1.75vw;
    }
  }

  @media screen and (min-width: 1025px) {
    .titre {
      font-size: 2vw;
    }

    .fa-2x {
      font-size: 1.3vw;
    }
  }

  @media print {
    .seDeconnecter {
      display: none;
    }
    .autreLettreTitre {
      color: blueviolet;
    }

    .titre {
      font-size: 8vw;
    }

    .pseudo {
      color: blueviolet;
      font-size: 4vw;
    }
  }
</style>
